/**
 * @returns {Boolean} - It returns true if the environment is NEXT_PUBLIC_APP.
 */
// eslint-disable-next-line func-names
export const isNextApp = (function () {
  return process.env.NEXT_PUBLIC_APP === "true"
})()
